// extracted by mini-css-extract-plugin
module.exports = {"ctn":"NotFound_ctn__30vz7","title":"NotFound_title__23RiO"};